import React, { FunctionComponent } from 'react';
import { Dropdown, DropdownProps } from 'semantic-ui-react';
import { IFilterValue } from '../../../../../utils/api/types';
import { IFilterConfig } from '../../../Context/TableFilterConfigContext';

export interface IMultiSelectFilterProps {
  item: IFilterConfig;
  value: IFilterValue[];
  onChange: (e: unknown, { value }: DropdownProps) => void;
}

export const MultiSelectFilter: FunctionComponent<IMultiSelectFilterProps> = ({ item, value, onChange }) => (
  <Dropdown
    multiple
    search
    selection
    selectOnBlur={false}
    clearable={!item.nonClearable}
    options={item.options}
    placeholder={item.label}
    value={value}
    onChange={onChange}
  />
);
